<template>

  <div v-if="load">
    <scale-loader/>
  </div>

  <tabs v-else-if="client_request_is_load" parent="client_request">
    <tab id="info" :name="translate('client_request.section.info')" :href="url+'/info'">
      <ClientRequestInfo v-if="client_request_is_load"
        :client_request="client_request_info"
        @update="get_client_request"
      />
    </tab>
  </tabs>

  <div v-else>
    <div class="wrapper-full-page section content">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="title text-danger">
              Client Request: {{cur_id}} not found
            </h2>
            <router-link :to="{path:'/client_request_list'}">
              To Client Request list
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import ClientRequestInfo from './Tabs/Info/Index.vue'

export default {
  name: 'ClientRequest',
  components: {
    ClientRequestInfo,
    Tab,
    Tabs,
  },
  data () {
    return {
      section: 'info',
      client_request_info: null,
    }
  },

  computed: {
    url () { return '/client_request/' + this.$route.params.client_request_id },
    cur_id () { return this.$route.params.client_request_id },
    load () { return !this.client_request_info?.id },
    client_request_is_load() { return this.client_request_info !== null }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'client_request_section') {
        this.get_client_request()
      }
    }
  },

  activated(){
    this.get_client_request()
  },

  methods: {
    get_client_request () {
      this.$http.v1.getClientRequest(this.$route.params.client_request_id, (response) => {
        this.client_request_info = response.data
        this.$store.commit('updateSelectedClientRequest', response.data)
      })
    }
  }
}

</script>
